<template>
  <div class="month">
    <h3>{{ month.month_and_year }}</h3>
    <header class="calendar--header">
      <div v-for="day in dayNames" :key="day" class="day-name">
        {{ day }}
      </div>
    </header>
    <div class="calendar--grid">
      <week
        v-for="week in weeks"
        :key="week"
        :days="week"
        :is-iframe="isIframe"
        :is-full-width="isFullWidth"
        :active-date-filter="activeDateFilter"
        @addToFilters="addToFilters($event.key, $event.value)"
        @removeFilter="removeFilter($event)"
        @loadCourseResults="populateCalendar($event)"
      />
    </div>
  </div>
</template>
<script>
  function splitArray(array, size) {
    let result = [];
    let arrayCopy = [...array];
    while (arrayCopy.length > 0) {
      result.push(arrayCopy.splice(0, size));
    }
    return result;
  }

  import Week from './week.vue';

  export default {
    components: {Week},
    props: {
      month: {
        type: Object,
        required: true,
      },
      isIframe: {
        type: Boolean,
        required: false,
      },
      isFullWidth: {
        type: Boolean,
        required: false,
      },
      dayNames: {
        type: Array,
        required: true,
      },
      activeDateFilter: {
        required: false,
        type: String,
        default: undefined,
      },
    },
    computed: {
      weeks: function () {
        return splitArray(this.month.days, 7);
      },
    },
    methods: {
      populateCalendar: function (filters) {
        this.$emit('loadCourseResults', filters);
      },
      addToFilters(key, value) {
        this.$emit('addToFilters', {key: key, value: value});
      },
      removeFilter(key) {
        this.$emit('removeFilter', key);
      },
    },
  };
</script>
